import { DEFAULT_HR_ZONES, MIN_HR, MAX_HR } from 'components/common/Constants'

export const getInnerBounds = (bounds?: number[]): number[] => {
  const limits = bounds?.slice(1, 6)
  // If the limit returned here becomes [], it will crash the Slider.
  if (limits === undefined || limits.length === 0) {
    return DEFAULT_HR_ZONES
  }
  return limits
}

export const canDisplayZoneLimits = (limits?: number[]): limits is number[] => {
  if (limits?.length !== DEFAULT_HR_ZONES.length || !limits.every(Number.isInteger)) {
    return false
  }
  const ascending = limits.every((value, idx) => idx === 0 || value >= limits[idx - 1])
  const max = limits[limits.length - 1]
  return ascending && limits[0] >= MIN_HR && max > MIN_HR && max <= MAX_HR
}

export const sliderMax = (maxHR: number): number => {
  return Number.isInteger(maxHR) && maxHR > MIN_HR && maxHR <= MAX_HR ? maxHR : MAX_HR
}

export const calculateZones = (value: number): number[] => {
  const result = Array<number>(0)
  result.push(0)
  // zone 1: <50 % of the max
  result.push(Math.floor(0.5 * value))
  // zone 2: >50 - 60 % of the max
  result.push(Math.floor(0.6 * value))
  // zone 3: >60 - 70 % of the max
  result.push(Math.floor(0.7 * value))
  // zone 4: >70 - 80 % of the max
  result.push(Math.floor(0.8 * value))
  // zone 5: >80 - 90 % of the max
  result.push(Math.floor(0.9 * value))
  // zone 6: >90 % of the max
  result.push(value)
  return result
}
